import React from 'react';
import { DEFAULT_LANGUAGE } from './config';

export const LocaleContext = React.createContext({
  locale: DEFAULT_LANGUAGE,
  setLocale: undefined,
});
